import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createVNode as _createVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createBlock as _createBlock } from "vue"

const _hoisted_1 = { class: "tab-details" }
const _hoisted_2 = { class: "list" }
const _hoisted_3 = { class: "header" }
const _hoisted_4 = { class: "title" }
const _hoisted_5 = { class: "items" }
const _hoisted_6 = { class: "item-header" }
const _hoisted_7 = { class: "name" }
const _hoisted_8 = ["onClick"]
const _hoisted_9 = {
  key: 0,
  class: "empty-data"
}

import { computed, onMounted, ref } from "vue";
import { useI18n } from "vue-i18n";

import { toast } from "@/common/utils/toast";

import { mediaList } from "@/common/api/rest/media";
import {
  collectionMediaList,
  collectionMediaCreate,
  collectionMediaDel,
  collectionMediaPatch,
} from "@/common/api/rest/collection-media";

import type { MediaType } from "@/common/types/media";
import type {
  CollectionMediaType,
  CollectionMediaPayloadType,
} from "@/common/types/collection-media";

import { sidebarListCheckbox, svgIcon } from "@/common/components";


export default /*@__PURE__*/_defineComponent({
  __name: 'media',
  props: {
    collectionId: {}
  },
  setup(__props: any) {

const { t } = useI18n();

const props = __props;

const list = ref<MediaType[]>([]);
const colletions = ref<CollectionMediaType[]>([]);

const loading = ref(false);
const showSidebar = ref(false);

const added = computed(() => colletions.value.map((item) => item.media_id));

async function fetchList() {
  await mediaList({
    full: true,
  })
    .then((response) => {
      const { success, data, message } = response;

      if (success) {
        list.value = data.list;
      } else {
        toast({ message: message, type: "error" });
      }
    })
    .catch(() => {
      toast({ message: t("error.default"), type: "error" });
    })
    .finally(() => {
      loading.value = false;
    });
}

async function fetchItems() {
  await collectionMediaList(props.collectionId, {
    full: true,
  })
    .then((response) => {
      const { success, data, message } = response;

      if (success) {
        colletions.value = data.list;
      } else {
        toast({ message: message, type: "error" });
      }
    })
    .catch(() => {
      toast({ message: t("error.default"), type: "error" });
    });
}

async function addItem(item: MediaType) {
  const payload: CollectionMediaPayloadType = {
    media_id: item.media_id,
  };

  await collectionMediaCreate(props.collectionId, payload)
    .then((response) => {
      const { success, message } = response;

      if (success) {
        fetchItems();
      } else {
        toast({ message: message, type: "error" });
      }
    })
    .catch(() => {
      toast({ message: t("error.default"), type: "error" });
    });
}

async function removeItem(data: MediaType) {
  const item = colletions.value.find((item) => item.media_id === data.media_id);

  if (!item) return;

  await collectionMediaDel(item.item_id)
    .then((response) => {
      const { success, message } = response;

      if (success) {
        fetchItems();
      } else {
        toast({ message: message, type: "error" });
      }
    })
    .catch(() => {
      toast({ message: t("error.default"), type: "error" });
    });
}

async function openSidebar() {
  await fetchList();
  showSidebar.value = true;
}

function closeSidebar() {
  showSidebar.value = false;
}

onMounted(() => {
  fetchItems();
});

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("section", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("div", _hoisted_4, _toDisplayString(_unref(t)("collection.labels.medias")), 1),
        _createElementVNode("button", {
          class: "btn btn-default w-8 h-8 p-0",
          onClick: _cache[0] || (_cache[0] = ($event: any) => (openSidebar()))
        }, [
          _createVNode(_unref(svgIcon), {
            icon: "bars",
            size: "1rem"
          })
        ])
      ]),
      _createElementVNode("div", _hoisted_5, [
        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(colletions.value, (item, itemIndex) => {
          return (_openBlock(), _createElementBlock("div", {
            key: itemIndex,
            class: "item"
          }, [
            _createElementVNode("div", _hoisted_6, [
              _createElementVNode("div", _hoisted_7, _toDisplayString(item.name), 1),
              _createElementVNode("button", {
                class: "btn btn-default w-5 h-5 p-0",
                onClick: ($event: any) => (removeItem(item as any))
              }, [
                _createVNode(_unref(svgIcon), {
                  icon: "close",
                  size: "0.75rem"
                })
              ], 8, _hoisted_8)
            ])
          ]))
        }), 128)),
        (!colletions.value.length)
          ? (_openBlock(), _createElementBlock("div", _hoisted_9, _toDisplayString(_unref(t)("collection.texts.empty_items")), 1))
          : _createCommentVNode("", true)
      ])
    ]),
    (showSidebar.value)
      ? (_openBlock(), _createBlock(_unref(sidebarListCheckbox), {
          key: 0,
          id: "media",
          width: _ctx.$store.getters.mobile ? '90vw' : '40rem',
          open: showSidebar.value,
          loading: loading.value,
          "outside-close": true,
          title: _unref(t)('collection.labels.medias'),
          list: list.value,
          "field-id": "media_id",
          "field-option": "name",
          added: added.value,
          onClose: _cache[1] || (_cache[1] = ($event: any) => (closeSidebar())),
          "onAdd:item": addItem,
          "onRemove:item": removeItem
        }, null, 8, ["width", "open", "loading", "title", "list", "added"]))
      : _createCommentVNode("", true)
  ]))
}
}

})